module.exports = __webpack_public_path__ + "static/media/document-text.bf231b12.svg";